import { IntentionallyLeftBlankPage, Page } from '@/models/page'
import _ from 'lodash'

export class PageCollection<T> {
  constructor (
    private pages: Array<Page<T>>,
    private startPageNumber: number = 1
  ) {}

  get list(): Array<Page<T>> {
    return this.pages
  }

  get isEmpty(): boolean {
    return this.list.length === 0
  }

  get maximumLoadedPageNumber(): number {
    return this.list.reduce(
      (accumulator, page) => page.loaded
        ? Math.max(accumulator, page.number)
        : accumulator,
      this.startPageNumber - 1
    )
  }

  find(number: number): Page<T> | null {
    return this.list.find(page => page.number === number) || null
  }

  add(page: Page<T>): void {
    this.pages = _.sortBy(
      this.makeMergedPages(this.pages, page),
      p => p.number
    )
  }

  fillInPreviousPages(beforeThis: number): void {

    if (this.startPageNumber >= beforeThis) {
      return
    }

    const previousPages = _.range(this.startPageNumber, beforeThis).map((number) => {
      const target = this.find(number)

      if (!target) {
        return new IntentionallyLeftBlankPage<T>(number)
      }

      return target
    })

    this.pages = [
      ...previousPages,
      ..._.filter(this.list, page => page.number >= beforeThis),
    ]
  }

  /**
   * Merge (add or update with the page number) a page into the list of pages.
   */
  private makeMergedPages(pages: Array<Page<T>>, page: Page<T>): Array<Page<T>> {
    const target = this.find(page.number)

    if (!target) {
      return [
        ...pages,
        page,
      ]
    }

    return pages.map((p) => {
      if (p.number !== page.number) {
        return p
      }

      return page
    })
  }
}
